import { gql } from "@apollo/client";
import {
  staffFragment,
  studentFragment,
  attachmentFragment,
} from "modules/CommonFragments";

export const AIMessageFragments = {
  AIMessage: gql`
    fragment aiMessageItem on AiMessage {
      id
      role
      authorType
      content
      metadata
      createdBy {
        ...staffItem
        ...studentItem
      }
      votes {
        myVote
      }
      usageMetricsId
      parentMessage {
        id
      }
      attachments {
        ...attachmentItem
      }
    }
    ${staffFragment.basicStaffDetails}
    ${studentFragment.basicStudentDetails}
    ${attachmentFragment.attachment}
  `,
};
